import { EventEmitter } from 'events';

import { sound } from '@pixi/sound';
import { setBannerAutoProceedGlobal, setIsQuickBtnOnGlobal, setIsSlamClickedGlobal, setIsSuperQuickBtnOnGlobal, setJurisdictionGlobal, setLanguageGlobal, setLinesGlobal, setMaxWinBtnClosedGlobal, setMobileDetect } from '../config/GlobalVariableConfig';
import { parserSpinResponse, resetSpinData } from '../server/getServerResposesFun';

declare const window: any;
const hacksaw = window.hacksawCasino;
const casinoChannel = hacksaw.PubSub.getChannel('casino');

export const casinoEventEmitter = new EventEmitter();

export class CasinoChannelHandler {
    private _betAcceptedToken: number | null = null;

    constructor() {
        this.subscribeToCasinoMessages();
        this.subscribeToGameRoundCasinoEvents();
    }

    private subscribeToCasinoMessages(): void {
        casinoChannel.subscribe('initGame', (data: any) => {
            console.log("subscribe:initGame", data);
            setLanguageGlobal(data.language);
            setMobileDetect(data.channel === "mobile" ? true : false);
            // Emit the 'initGameReady' event
            casinoEventEmitter.emit('initGameReady');

        });

        casinoChannel.subscribe('startGame', (data: any) => {
            console.log("subscribe:startGame", data);
            console.log("jurisdiction", data.jurisdiction);
            console.log("lines", data.gameInfoData.lines);

            setLinesGlobal(data.gameInfoData.lines);


            setJurisdictionGlobal(data.jurisdiction);
            // reportGameStarted();
            // app.init should be called here

            // CasinoChannelHandler.reportGameStarted();

        });

        casinoChannel.subscribe('scaleResize', (data: any) => {
            console.log("scaleResize", data)
            casinoEventEmitter.emit('scaleResize');
        });


        casinoChannel.subscribe('enableSound', () => {
            console.log("enableSound")
            casinoEventEmitter.emit('enableSound');

        });
        casinoChannel.subscribe('muteSound', () => {
            console.log("muteSound")
            casinoEventEmitter.emit('muteSound');

        });

        casinoChannel.subscribe('enableMusic', () => {
            console.log("enableMusic")
            casinoEventEmitter.emit('enableMusic');

        });

        casinoChannel.subscribe('muteMusic', () => {
            console.log("muteMusic")
            casinoEventEmitter.emit('muteMusic');
        });

        casinoChannel.subscribe('enableTurbo', () => {
            console.log("enableTurbo")
            // casinoEventEmitter.emit('enableTurbo');
            setIsQuickBtnOnGlobal(true);

        });
        casinoChannel.subscribe('disableTurbo', () => {
            console.log("disableTurbo")
            // casinoEventEmitter.emit('disableTurbo');
            setIsQuickBtnOnGlobal(false);

        });

        casinoChannel.subscribe('enableSuperTurbo', () => {
            console.log("enableSuperTurbo")
            // casinoEventEmitter.emit('enableSuperTurbo');
            setIsSuperQuickBtnOnGlobal(true);

        });

        casinoChannel.subscribe('disableSuperTurbo', () => {
            console.log("disableSuperTurbo")
            // casinoEventEmitter.emit('disableSuperTurbo');
            setIsSuperQuickBtnOnGlobal(false);

        });

        casinoChannel.subscribe('showResult', () => {
            console.log("showResult");
            setIsSlamClickedGlobal(true);
            // casinoEventEmitter.emit('showResult');
        });



        casinoChannel.subscribe('updateBetLevel', (data: any) => {
            // console.log("updateBetLevel", data);

            const minSpeed = 0.5; // Lowest pitch
            const maxSpeed = 2;   // Highest pitch
            const normalizedLevel = Math.max(1, Math.min(data.index, 28)); // Ensure level is between 1 and 10
            const speedBet = minSpeed + (normalizedLevel - 1) * (maxSpeed - minSpeed) / 27;

            casinoEventEmitter.emit('betChanged');
            sound.play('bet-level', { volume: 0.15, speed: speedBet });


        });


        casinoChannel.subscribe('startAutoplay', (data: any) => {
            console.log("autoplayStarted", data);

            if (data.stopAutoplayOnFeature === false) {

                setBannerAutoProceedGlobal(true);
            }
        });

        casinoChannel.subscribe('autoplayEnded', () => {
            console.log("autoplayEnded");

            setBannerAutoProceedGlobal(false);

        });


        casinoChannel.subscribe('dialogClosed', () => {
            console.log("dialogClosed");
            setMaxWinBtnClosedGlobal(true);
        });


    }


    public static reportGameStarted() {
        casinoChannel.publish('gameStarted');
        console.log("publish:gameStarted");
    }


    public static reportGameReady(): void {
        casinoChannel.publish('gameReady');
        console.log("publish:gameReady");
    }


    public static reportGameLoaded(): void {
        const gameLoadedData = {
            gameRoundDelays: 5000,
            uiCustomSettings: [
                {
                    type: 'SuperTurbo',
                    settings: { available: true }
                },
                {
                    type: 'RevealBehavior',
                    settings: { behavior: 'SPIN' }
                },
                {
                    type: 'FeatureBuy',
                    settings: {
                        items: getFeatureBuyItems()
                    }
                },

            ]
        };

        casinoChannel.publish('gameLoaded', gameLoadedData);
        console.log("publish:gameLoaded");

        function getFeatureBuyItems() {
            return [
                {
                    bonusGameId: "mod_bonus",
                    name: 'bonushunt_featurespins_uc',
                    description: 'bonushunt_featurespins_desc',
                    volatility: 'high',
                    image: 'gameinfoassets/buy_image_1.png',
                },
                {
                    bonusGameId: "mod_holdnwin",
                    name: 'mod_holdnwin_featurespins_uc',
                    description: 'mod_holdnwin_featurespins_desc',
                    volatility: 'high',
                    image: 'gameinfoassets/buy_image_2.png',
                },
                {
                    bonusGameId: "fs",
                    name: 'free_spins_uc',
                    description: 'free_spins_desc',
                    volatility: 'high',
                    image: 'gameinfoassets/buy_image_3.png',
                }
            ];
        }
    }




    /********** Game Round related functions ***************** */


    private subscribeToGameRoundCasinoEvents() {
        // Subscribe to the 'roundEnded' event
        casinoChannel.subscribe('roundEnded', (data: any) => {
            console.log('casinoChannel-roundEnded', data);
            casinoEventEmitter.emit('roundEnded', data);

            // Unsubscribe from 'betAccepted' after round ends
            if (this._betAcceptedToken !== null) {
                casinoChannel.unsubscribe(this._betAcceptedToken);
                this._betAcceptedToken = null;
            }
        });



        // Subscribe to the 'betDeclined' event
        casinoChannel.subscribe('roundStarted', (data: any) => {

            resetSpinData();
            console.log('casinoChannel-roundStarted', data);
            casinoEventEmitter.emit('roundStarted');

            sound.play('click', { volume: 0.5 });

            // Subscribe to 'betAccepted' event when a round starts
            casinoChannel.subscribe('betDeclined', (spinResponseData: any) => {
                console.log("casinoChannel-betDeclined", spinResponseData);
                casinoEventEmitter.emit('betDeclined');
            });

            // Subscribe to 'betAccepted' event when a round starts
            this._betAcceptedToken = casinoChannel.subscribe('betAccepted', (spinResponseData: any) => {
                console.log("casinoChannel-betAccepted", spinResponseData);
                casinoEventEmitter.emit('betAccepted', spinResponseData);

                parserSpinResponse(spinResponseData);

                this.reportGameRoundStarted();
                // this.reportResultDisplay();
            });
        });
    }

    public reportGameRoundStarted() {
        casinoChannel.publish('gameRoundStarted');
        console.log('casinoChannel-gameRoundStarted');
    }

    public reportResultDisplay() {
        casinoChannel.publish('resultDisplay');
        console.log('casinoChannel-resultDisplay');
    }

    public reportGameRoundCompleted() {
        casinoChannel.publish('gameRoundCompleted');
        console.log('casinoChannel-gameRoundCompleted');
    }

    public reportFeatureEnter() {
        casinoChannel.publish('featureEnter', { featureName: 'fs' });
        console.log('casinoChannel-featureEnter');
    }

    public reportFeatureRoundStarted() {
        casinoChannel.publish('featureRoundStarted', { uistate: 'freespins', gameMode: 'fs_' });
        console.log("casinoChannel-featureRoundStarted");
    }

    public reportUpdateFeatureCounter(counterValue: number) {
        casinoChannel.publish('updateFeatureCounter', { counterValue: counterValue });
        console.log("casinoChannel-updateFeatureCounter", counterValue);
    }

    public reportFeatureRoundCompleted(winAmount: string) {
        casinoChannel.publish('featureRoundCompleted', { winAmount: winAmount });
        console.log("casinoChannel-featureRoundCompleted");
    }


    public reportUpdateFeatureTotalWin(winAmount: string) {
        casinoChannel.publish('updateFeatureTotalWin', { totalWinAmount: winAmount });
        console.log("casinoChannel-featureRoundCompleted");
    }


    public reportFeatureExit() {
        casinoChannel.publish('featureExit');
        console.log("casinoChannel-featureExit");
    }


    public reportMaxWin() {
        casinoChannel.publish('showMaxWinDialog');
        console.log("publish:showMaxWinDialog");
    }


}
